import { Activity, BodyProps } from "@ofqual/portal-activity-feed";
import { fieldLabels } from "../../item/fieldLabels";

export type ActivityDialogProps = {
  activity: Activity;
  onClose: () => void;
};

export enum DialogType {
  ActivityAction,
  SendMessage,
}

export interface EntityDialog {
  dialogType: DialogType;
  focussedActivity?: Activity;
}

export type FieldChange = {
  field: keyof typeof fieldLabels;
  oldValue: string | Array<any> | null;
  newValue: string | Array<any> | null;
};

export type ActivityBody = {
  id: string;
  changes: FieldChange[];
};

export type AssignRecipientBody = {
  assignments: Assignment[];
};

export type ActivityDocument = {
  blobId: string;
  fileName: string;
  contentType: string;
}

export type AttachmentActivityBody = {
  message: string;
  documents: ActivityDocument[];
  recipientOrgs: string[];
  org?: string;
};

export type Assignment = {
  organisationName: string;
  assignedToUpn: string;
  assignedToDisplayName: string;
};

export type AttachmentBodyProps = {
  bodyProps: BodyProps<AttachmentActivityBody>;
};